





















































import { Vue, Component } from 'vue-property-decorator';
import MenuCard from '@/components/brand/MenuCard.vue';
import brandModule from '../../store/modules/brand.module';
import { VIDEO_ID, ASSET_URL } from '../../common/config';
import BrandAsset from '../../common/model/BrandAsset';

@Component({
  components: {
    MenuCard,
  },
})
export default class VideoVault extends Vue {
  cdnUrl = ASSET_URL;

  commonVideoOptions = { width: 700 };

  get brandVideos(): Array<BrandAsset> {
    if (!brandModule.brand) {
      return [];
    }
    if (!brandModule.brand.brand_assets) {
      return [];
    }
    const brandVideos = brandModule.brand.brand_assets.filter(
      asset => asset.category.id === VIDEO_ID,
    );
    return brandVideos;
  }

  onResize(): void {
    const cardElement: any = document.querySelector('#video-card-0');
    if (!cardElement) {
      this.commonVideoOptions = { width: 700 };
    }
    const width = cardElement.offsetWidth - 2;
    this.commonVideoOptions = { width };
  }

  mounted(): void {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  beforeDestroy(): void {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize);
  }

  get secondaryColor(): string {
    return '#000000';
  }

  get fontColor(): string {
    return '#FFFFFF';
  }
}
